import React from 'react';
import Draggable from 'react-draggable';
import ScrollAreaComponent from 'react-scrollbar';
import platformDetection from '../../components/utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import playController from '../utils/PlayController';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import dragManager from '../utils/DragManager';
import timelineDragManager from '../audioEditor/utils/TimelineDragManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import masterUniverseUtils from '../utils/MasterUniverseUtils';

const HorizontalScrollBar = React.createClass({
    getInitialState() {
        playController.updateScrollForIOS = this.updateScroll;
        playController.startScroll = this.startScroll;
        playController.moveScroll = this.moveScroll;
        playController.endScroll = this.endScroll;

        const startPos = this.getThumbPosition();

        return {
            currentX: startPos,
            initialX: startPos,
            scrollWidth: this.props.scrollWidth
        };
    },
    startScroll(e) {
        var globalX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            globalX = e.nativeEvent.touches[0].clientX;

        if (!globalX)
            return;

        this.setState({
            initialX: this.state.currentX,
            startX: globalX
        });
    },
    moveScroll(e) {
        var target = this.props.target;
        var globalX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            globalX = e.nativeEvent.touches[0].clientX;

        if (!globalX || !this.state.startX)
            return;

        var deltaX = -1 * (globalX - this.state.startX);
        const thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
        const scale = this.props.scrollWidth / this.props.visibleWidth;
        var scrollPosition = this.state.initialX + deltaX;

        if (scrollPosition < 0)
            scrollPosition = 0;

        if (scrollPosition > this.props.visibleWidth - thumbWidth)
            scrollPosition = this.props.visibleWidth - thumbWidth;

        this.setState({
            currentX: scrollPosition
        });

        target.style.left = - (scrollPosition * scale - this.props.paddingLeft) + 'px';
    },
    endScroll() {
        this.setState({
            startX: undefined
        });
    },
    onDragStart() {
        this.setState({
            initialX: this.state.currentX
        });
    },
    onDragMove(e, coreEvent) {
        var target = this.props.target;

        const thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
        const scale = this.props.scrollWidth / this.props.visibleWidth;
        var scrollPosition = this.state.initialX + coreEvent.lastX;

        if (scrollPosition < 0)
            scrollPosition = 0;

        if (scrollPosition > this.props.visibleWidth - thumbWidth)
            scrollPosition = this.props.visibleWidth - thumbWidth;

        this.setState({
            currentX: scrollPosition
        });

        target.style.left = - (scrollPosition * scale - this.props.paddingLeft) + 'px';
    },
    onDragEnd() {
        this.setState({
            initialX: this.state.currentX
        });
    },
    getThumbPosition() {
        const scaleFactor = this.props.visibleWidth / this.props.scrollWidth;
        var currentSlideTime = audioEditorUtils.getCurrentSlidePosition('', true);
        var currentSlidePosition = audioEditorUtils.getSlideWidth(currentSlideTime);
        var leftSpace = currentSlidePosition - this.props.visibleWidth;
        const thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
        var thumbPosition = leftSpace * scaleFactor;

        if (thumbPosition < 0)
            thumbPosition = 0;

        if (thumbPosition > this.props.visibleWidth - thumbWidth)
            thumbPosition = this.props.visibleWidth - thumbWidth;

        return thumbPosition;
    },
    checkScrollPosition() {
        if (this.props.target)
            this.props.target.style.top = '5px';

        if (this.state.scrollWidth != this.props.scrollWidth && this.props.scrollWidth > this.props.visibleWidth) {
            setTimeout(function() {
                const thumbPos = this.getThumbPosition();
                const scale = this.props.scrollWidth / this.props.visibleWidth;

                this.setState({
                    scrollWidth: this.props.scrollWidth,
                    currentX: thumbPos,
                    initialX: thumbPos
                });

                this.props.target.style.left = - (thumbPos * scale - this.props.paddingLeft) + 'px';
            }.bind(this), 5);
        }
    },
    updateScroll(position) {
        const scaleFactor = this.props.visibleWidth / this.props.scrollWidth;
        const thumbWidth = scaleFactor * this.props.visibleWidth;
        var thumbPosition = position * scaleFactor;
        const scale = this.props.scrollWidth / this.props.visibleWidth;

        if (thumbPosition < 0)
            thumbPosition = 0;

        if (thumbPosition > this.props.visibleWidth - thumbWidth)
            thumbPosition = this.props.visibleWidth - thumbWidth;

        this.setState({
            currentX: thumbPosition,
            initialX: thumbPosition
        });

        if (this.props.target)
            this.props.target.style.left = - (thumbPosition * scale - this.props.paddingLeft) + 'px';
    },
    onClick(e) {
        if (e.nativeEvent.target.className.indexOf('react-draggable') != -1)
            return;

        var localX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            localX = e.nativeEvent.touches[0].clientX;
        else
            localX = e.clientX;

        if (!localX)
            return;

        var clientBoundingRect = this.refs.track.getBoundingClientRect();
        var globalX = clientBoundingRect.left;

        localX = localX - globalX;

        const thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
        const scale = this.props.scrollWidth / this.props.visibleWidth;

        if (localX < 0)
            localX = 0;

        if (localX > this.props.visibleWidth - thumbWidth)
            localX = this.props.visibleWidth - thumbWidth;

        this.setState({
            currentX: localX
        });

        this.props.target.style.left = - (localX * scale - this.props.paddingLeft) + 'px';
    },
    render() {
        this.checkScrollPosition();

        const scrollStyle = {
            // background: 'red',
            height: 30,
            width: this.props.visibleWidth,
            position: 'fixed',
            left: audioToolUtils.buttonsHolderWidth(),
            cursor: 'default',
            userDrag: 'none',
            bottom: 0,
            borderRadius: 10,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)'
        };

        if (this.props.visibleWidth > this.props.scrollWidth)
            return <div style={scrollStyle}/>;

        const scale = this.props.visibleWidth / this.props.scrollWidth;

        const thumbStyle = {
            height: 30,
            width: this.props.visibleWidth * scale,
            position: 'absolute',
            cursor: 'default',
            left: this.state.currentX,
            borderRadius: 10,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
        };

        return (
            <div style={scrollStyle} ref="track" onTouchStart={this.onClick} onClick={this.onClick}>
                <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                    <div ref='thumb' style={thumbStyle}/>
                </Draggable>
            </div>
        );
    }
});

const VerticalScrollBar = React.createClass({
    getInitialState() {
        const startPos = this.getThumbPosition();

        return {
            currentY: startPos,
            initialY: startPos,
            scrollHeight: this.props.scrollHeight
        };
    },
    onDragStart() {
        this.setState({
            initialY: this.state.currentY
        });
    },
    onDragMove(e, coreEvent) {
        var target = this.props.target;

        const thumbHeight = this.props.visibleHeight / this.props.scrollHeight * this.props.visibleHeight;
        const scale = this.props.scrollHeight / this.props.visibleHeight;
        var scrollPosition = this.state.initialY + coreEvent.lastY;

        if (scrollPosition < 0)
            scrollPosition = 0;

        if (scrollPosition > this.props.visibleHeight - thumbHeight)
            scrollPosition = this.props.visibleHeight - thumbHeight;

        this.setState({
            currentY: scrollPosition
        });

        target.style.top = - (scrollPosition * scale - this.props.paddingTop) + 'px';
    },
    onDragEnd() {
        this.setState({
            initialY: this.state.currentY
        });
    },
    getThumbPosition() {
        return 0;
    },
    checkScrollPosition() {
        // if (this.props.target)
        //     this.props.target.style.top = '5px';

        if (this.state.scrollHeight != this.props.scrollHeight && this.props.scrollHeight > this.props.visibleHeight) {
            setTimeout(function() {
                const thumbPos = this.getThumbPosition();
                const scale = this.props.scrollHeight / this.props.visibleHeight;

                this.setState({
                    scrollHeight: this.props.scrollHeight,
                    currentY: thumbPos,
                    initialY: thumbPos
                });

                this.props.target.style.top = - (thumbPos * scale - this.props.paddingTop) + 'px';
            }.bind(this), 5);
        }
    },
    onClick(e) {
        if (e.nativeEvent.target.className.indexOf('react-draggable') != -1)
            return;

        var localY;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            localY = e.nativeEvent.touches[0].clientY;
        else
            localY = e.clientY;

        if (!localY)
            return;

        var clientBoundingRect = this.refs.track.getBoundingClientRect();
        var globalY = clientBoundingRect.top;

        localY = localY - globalY;

        const thumbHeight = this.props.visibleHeight / this.props.scrollHeight * this.props.visibleHeight;
        const scale = this.props.scrollHeight / this.props.visibleHeight;

        if (localY < 0)
            localY = 0;

        if (localY > this.props.visibleHeight - thumbHeight)
            localY = this.props.visibleHeight - thumbHeight;

        this.setState({
            currentY: localY
        });

        this.props.target.style.top = - (localY * scale - this.props.paddingTop) + 'px';
    },
    render() {
        this.checkScrollPosition();

        var topPos = this.props.top;

        if (this.props.extraTopPadding > 0)
            topPos = topPos + this.props.extraTopPadding;

        const scrollStyle = {
            // background: 'red',
            top: topPos,
            width: properties.AUDIO_BROWSER_SCROLL_WIDTH,
            height: this.props.visibleHeight,
            position: 'fixed',
            cursor: 'default',
            userDrag: 'none',
            right: 0,
            borderRadius: 10,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)'
        };

        if (this.props.visibleHeight > this.props.scrollHeight)
            return <div style={scrollStyle}/>;

        const scale = this.props.visibleHeight / this.props.scrollHeight;

        const thumbStyle = {
            width: scrollStyle.width,
            height: this.props.visibleHeight * scale,
            position: 'absolute',
            cursor: 'default',
            top: this.state.currentY,
            borderRadius: 10,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
        };

        return (
            <div style={scrollStyle} ref="track" onTouchStart={this.onClick} onClick={this.onClick}>
                <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                    <div ref='thumb' style={thumbStyle}/>
                </Draggable>
            </div>
        );
    }
});

export const ScrollableComponent = React.createClass({
    getInitialState() {
        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList') {
            dragManager.moveScroll = this.updateScrollWhenDrag;
            timelineDragManager.moveScroll = this.updateScrollWhenDrag;
        }

        return {
            currentY: 0,
            initialY: 0,
            thumbY: 0,
            initialThumbY: 0,
            scrollWidth: 0,
            currentSlideIndex: -1
        };
    },
    componentDidMount() {
        setTimeout(this.refreshView, 20);
        document.addEventListener('keydown', this.onKeyDown);
    },
    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
    },
    updateScrollWhenDrag(value = 1) {
        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList') {
            var scrollElement = this.refs.scrollElement;

            if (scrollElement) {
                var step = properties.AUTO_SCROLL_STEP;

                if (value > 0)
                    scrollElement.scrollLeft = scrollElement.scrollLeft + step;
                else
                    scrollElement.scrollLeft = scrollElement.scrollLeft - step;
            }
        }
    },
    isSlideCommand() {
        const state = storeManager.getState();
        const isSlideComand = state.currentSlide.isSlideCommand;

        if (isSlideComand == true)
            return true;
        else
            return false;
    },
    getLastSlideWidth(isLeft = true) {
        const state = storeManager.getState();
        var currentIndex = state.currentSlide.currentSlideIndex;
        var slides = state.production.slides;
        var slide;

        if (currentIndex > 0 && currentIndex < slides.length - 1) {
            if (!isLeft) // right
                currentIndex = currentIndex - 1;
            else // left
                currentIndex = currentIndex + 1;

            slide = slides[currentIndex];
        }

        if (slide)
            return audioEditorUtils.getSlideWidth(slide.time);
        else
            return 0;
    },
    onKeyDown(e) {
        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList' && this.isSlideCommand()) {
            var scrollElement = this.refs.scrollElement;

            if (scrollElement) {
                const scrollWidth = this.getScrollWidth();
                const visibleWidth = this.props.componentProperties.width;
                const thumbWidth = visibleWidth / scrollWidth * visibleWidth;
                const elementsLength = this.props.componentProperties.elementsLength > 1 ? this.props.componentProperties.elementsLength : this.props.componentProperties.elements.length;
                var step;

                if (e.keyCode == 39) { // Right arrow
                    step = playController.isAudioEditorMode() ? this.getLastSlideWidth(false) : (scrollWidth - thumbWidth) / elementsLength;
                    scrollElement.scrollLeft = scrollElement.scrollLeft + step;
                    e.preventDefault();
                    return false;
                } else
                if (e.keyCode == 37) { // Left arrow
                    step = playController.isAudioEditorMode() ? this.getLastSlideWidth(true) : (scrollWidth - thumbWidth) / elementsLength;
                    scrollElement.scrollLeft = scrollElement.scrollLeft - step;
                    e.preventDefault();
                    return false;
                }
            }
        }
    },
    refreshView() {
        this.forceUpdate();
    },
    getScrollWidth() {
        if (this.props.componentProperties.scrollWidth > 0)
            return this.props.componentProperties.scrollWidth;

        var width = 0;

        if (this.refs.scrollArea)
            width =  this.refs.scrollArea.scrollWidth;

        return width;
    },
    getScrollHeight() {
        if (this.props.componentProperties.scrollHeight > 0)
            return this.props.componentProperties.scrollHeight;

        var height = 0;

        if (this.refs.scrollArea)
            height =  this.refs.scrollArea.scrollHeight;

        return height;
    },
    onDragStart() {
        if (platformDetection.isTouchableDevice() == false)
            return;

        this.setState({
            initialY: this.state.currentY
        });
    },
    onDragMove(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == false)
            return;

        this.move(coreEvent.lastY);
    },
    move(offset) {
        const scrollHeight = this.getScrollHeight() + this.props.componentProperties.paddingTop;
        const visibleHeight = this.props.componentProperties.height;

        if (visibleHeight >= scrollHeight)
            return;

        const thumbHeight = visibleHeight / scrollHeight * visibleHeight;

        var scrollAreaY = this.state.initialY + offset;

        if (scrollAreaY > 0)
            scrollAreaY = 0;

        if (scrollAreaY < -1 * (scrollHeight - visibleHeight))
            scrollAreaY = -1 * (scrollHeight - visibleHeight);

        const thumbPosition = - scrollAreaY * (visibleHeight - thumbHeight) / (scrollHeight - visibleHeight);

        this.setState({
            currentY: scrollAreaY,
            thumbY: thumbPosition
        });
    },
    onDragEnd() {
        if (platformDetection.isTouchableDevice() == false)
            return;

        this.setState({
            initialY: this.state.currentY
        });
    },
    scrollDragStart() {
        this.setState({
            initialThumbY: this.state.thumbY,
            initialY: this.state.currentY
        });
    },
    scrollDragMove(offset) {
        const scrollHeight = this.getScrollHeight() + this.props.componentProperties.paddingTop;
        const visibleHeight = this.props.componentProperties.height;

        if (visibleHeight >= scrollHeight)
            return;

        const thumbHeight = visibleHeight / scrollHeight * visibleHeight;
        var thumbPosition = this.state.initialThumbY + offset;

        if (thumbPosition < 0)
            thumbPosition = 0;

        if (thumbPosition > (visibleHeight - thumbHeight))
            thumbPosition = visibleHeight - thumbHeight;

        const scale = (visibleHeight - thumbHeight) / (scrollHeight - visibleHeight);
        var scrollAreaY = - thumbPosition / scale;

        this.setState({
            thumbY: thumbPosition,
            currentY: scrollAreaY
        });
    },
    scrollDragEnd() {
        this.setState({
            initialY: this.state.currentY
        });
    },
    refreshScroll() {
        this.forceUpdate();
    },
    checkScroll() {
        setTimeout(this.updateScrollPosition, 10);
    },
    updateScrollPosition() {
        if (this.props.componentProperties.isHorizontal == true) {
            const scrollWidth = this.getScrollWidth();
            const currentSlideIndex = storeManager.getState().currentSlide.currentSlideIndex;

            if ((this.state.scrollWidth > 0 && Math.abs(scrollWidth - this.state.scrollWidth) > 60) || (mouseUtils.isKeyboardShortcut == true && currentSlideIndex != this.state.currentSlideIndex && this.state.currentSlideIndex > -1)) {
                var scrollElement = this.refs.scrollElement;
                const state = storeManager.getState();
                const visibleWidth = this.props.componentProperties.width;
                const currentSlidePosition = (properties.SLIDE_ITEM_WIDTH + properties.SLIDE_GAP) * (state.currentSlide.currentSlideIndex + 1);
                const outsideOffset = currentSlidePosition - visibleWidth;

                if (platformDetection.isTouchableDevice() == true) {
                    if (this.refs.scrollView)
                        this.refs.scrollView.scrollXTo(outsideOffset);
                } else {
                    if (scrollElement)
                        scrollElement.scrollLeft = outsideOffset;
                }
            }

            if (currentSlideIndex != this.state.currentSlideIndex ) {
                this.setState({
                    currentSlideIndex: currentSlideIndex
                });
            }

            if (scrollWidth != this.state.scrollWidth) {
                this.setState({
                    scrollWidth: scrollWidth
                });
            }
        }

        mouseUtils.isKeyboardShortcut = false;
    },
    isAudioEditor() {
        const componentProperties = this.props.componentProperties;

        if (componentProperties.isAudioEditor == true)
            return true;
        else
            return false;
    },
    onScrollHandler(e) {
        const componentProperties = this.props.componentProperties;

        if (componentProperties.usePagination) {
            // keep the scrolling functionality
        } else {
            if (!masterUniverseUtils.useThumbnailsLazyLoading())
                return;
        }

        var scrollVisibleHeight = componentProperties.height;
        var currentTarget = e.currentTarget;
        var scrollTop = 0;
        var scrollHeight = 0;

        if (currentTarget && currentTarget.scrollTop) {
            scrollTop = currentTarget.scrollTop;
            scrollHeight = currentTarget.scrollHeight;
        } else
        if (e.topPosition >= 0) {
            scrollTop = e.topPosition;
            scrollHeight = e.realHeight;
        }

        if (Math.abs(scrollHeight - scrollTop - scrollVisibleHeight) <= 20) { // load new scroll page
            if (componentProperties.uploadNewPage)
                componentProperties.uploadNewPage(scrollTop);
        } else {
            if (componentProperties.updateScrollHandler)
                componentProperties.updateScrollHandler(scrollTop);
        }
    },
    render() {
        const componentProperties = this.props.componentProperties;
        const height = componentProperties.height - componentProperties.paddingTop;

        var backgroundColor = 'white';

        if (componentProperties.backgroundColor != undefined)
            backgroundColor = componentProperties.backgroundColor;

        var wrapperStyle = {
            width: componentProperties.width - componentProperties.paddingLeft,
            height: height,
            top: componentProperties.top,
            paddingTop: componentProperties.paddingTop,
            paddingLeft: componentProperties.paddingLeft,
            display: componentProperties.displayState,
            backgroundColor: backgroundColor,
            position: 'absolute',
            overflowX: 'hidden',
            overflowY: 'auto',
            cursor: 'default',
            userDrag: 'none'
        };

        var scrollAreaStyle = {
            position: 'absolute'
        };

        var scroll;

        if (componentProperties.isHorizontal == true) {
            wrapperStyle.overflowX = 'scroll';
            wrapperStyle.overflowY = 'hidden';
            wrapperStyle.backgroundColor = undefined;
            scrollAreaStyle.width = componentProperties.scrollWidth;
        }

        if (platformDetection.isTouchableDevice() == true) {
            if (componentProperties.isHorizontal == true) {
                const scrollWidth = this.getScrollWidth() + componentProperties.paddingLeft;

                wrapperStyle.overflowX = 'hidden';
                wrapperStyle.display = 'contents';
                wrapperStyle.backgroundColor = undefined;
                scrollAreaStyle.width = scrollWidth;

                if (this.isAudioEditor()) {
                    return (
                        <div className='scrollComponent' ref='scrollElement' style={wrapperStyle} id={componentProperties.id}>
                            <div className='scrollComponent scrollForIOS' ref='scrollArea' style={scrollAreaStyle}>
                                 {componentProperties.elements}
                             </div>
                            <HorizontalScrollBar scrollWidth={scrollWidth} visibleWidth={componentProperties.width} target={this.refs.scrollArea} paddingLeft={componentProperties.paddingLeft}/>
                        </div>
                    );
                }
            } else {
                if (this.isAudioEditor()) {
                    wrapperStyle.overflowX = 'hidden';
                    wrapperStyle.overflowY = 'hidden';
                    wrapperStyle.backgroundColor = undefined;
                    scrollAreaStyle.height = componentProperties.scrollHeight;

                    var searchHeight = properties.CLIPART_BUTTON_HEIGHT + apiServiceUtils.getNoInternetConnectionAlertHeight();

                    return (
                        <div className='scrollComponent' ref='scrollElement' style={wrapperStyle} id={componentProperties.id}>
                            <div className='scrollComponent scrollVerticalForIos' ref='scrollArea' style={scrollAreaStyle}>
                                {componentProperties.elements}
                            </div>
                            <VerticalScrollBar scrollHeight={componentProperties.scrollHeight} extraTopPadding={componentProperties.extraTopPadding} visibleHeight={componentProperties.height} top={componentProperties.top + searchHeight} target={this.refs.scrollArea} paddingTop={componentProperties.paddingTop}/>
                        </div>
                    );
                }

                wrapperStyle.overflowY = 'hidden';
                scrollAreaStyle.top = this.state.currentY + componentProperties.paddingTop;
            }
        }

        var isTouchableNonAudioEditor = (platformDetection.isTouchableDevice() && !this.isAudioEditor());
        var isHorizontal = componentProperties.isHorizontal == true;

        if (isTouchableNonAudioEditor) {
            if (!isHorizontal) { // Vertical
                const componentWidth = componentProperties.width - componentProperties.paddingLeft;
                const componentHeight = height;
                var scrollHeight = 0;

                if (componentProperties.scrollHeight > 0)
                    scrollHeight = componentProperties.scrollHeight + componentProperties.paddingTop;

                const myScrollbar = {
                    width: componentWidth,
                    height: componentHeight
                };

                var scrollParentStyle = {
                    width: componentWidth
                };

                if (scrollHeight > 0)
                    scrollParentStyle.height = scrollHeight;

                wrapperStyle.overflowY = 'hidden';

                var trackStyle = {
                    opacity: 1,
                    background: 'white',
                    borderRadius: 10,
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
                    position: 'absolute'
                };

                var thumbStyle = {
                    position: 'absolute',
                    background: 'white',
                    borderRadius: 10,
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
                };

                if (platformDetection.isMixedDevice() == true && platformDetection.isIOS() == false) {
                    trackStyle.width = 15;
                    thumbStyle.width = 15;
                }

                return (
                    <div className='scrollComponent' style={wrapperStyle} id={componentProperties.id}>
                            <ScrollAreaComponent style={myScrollbar} speed={0.8} horizontal={false} smoothScrolling={true} stopScrollPropagation={true} onScroll={this.onScrollHandler} verticalContainerStyle={trackStyle} verticalScrollbarStyle={thumbStyle}>
                                <div className='scrollComponent' style={scrollParentStyle}>
                                    {componentProperties.elements}
                                </div>
                            </ScrollAreaComponent>
                    </div>
                );
            } else { // Horizontal
                const componentWidth = componentProperties.width;
                const componentHeight = componentProperties.height;
                var scrollWidth = componentProperties.scrollWidth;

                const myScrollbar = {
                    width: componentWidth,
                    height: componentHeight
                };

                var scrollParentStyle = {
                    width: scrollWidth,
                    height: componentHeight,
                    paddingTop: 5
                };

                var scrollStyle = {
                    width: scrollWidth,
                    height: componentHeight
                };

                wrapperStyle.overflowX = 'hidden';
                wrapperStyle.overflowY = 'hidden';

                var hiddenTrackStyle = {
                    opacity: 1,
                    background: 'white',
                    borderRadius: 10,
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
                    position: 'absolute',
                    width: componentWidth,
                    height: 15,
                    top: 69
                };

                var trackStyle = {
                    opacity: 1,
                    background: 'white',
                    borderRadius: 10,
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
                    position: 'absolute'
                };

                var thumbStyle = {
                    position: 'absolute',
                    background: 'white',
                    borderRadius: 10,
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
                };

                trackStyle.height = 15;
                trackStyle.bottom = 2;

                thumbStyle.height = 15;

                var isScrollBarEnabled = true;

                if (platformDetection.isIOS() == true && mouseUtils.isActive() == true)
                    isScrollBarEnabled = false;

                this.checkScroll();
                mouseUtils.refreshScrollFunction = this.refreshScroll;

                return (
                    <div className='scrollComponent' style={wrapperStyle} id={componentProperties.id}>
                        <ScrollAreaComponent ref='scrollView' style={myScrollbar} contentStyle={scrollParentStyle} speed={0.8} horizontal={isScrollBarEnabled} vertical={false} smoothScrolling={true} stopScrollPropagation={true} horizontalContainerStyle={trackStyle} horizontalScrollbarStyle={thumbStyle} swapWheelAxes={true}>
                            <div className='scrollComponent' style={scrollStyle}>
                                {componentProperties.elements}
                            </div>
                        </ScrollAreaComponent>
                        <div style={hiddenTrackStyle}/>
                    </div>
                );
            }
        } else {
            this.checkScroll();

            return (
                <div className='scrollComponent' ref='scrollElement' style={wrapperStyle} id={componentProperties.id} onScroll={this.onScrollHandler}>
                    <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                        <div className='scrollComponent' ref='scrollArea' style={scrollAreaStyle}>
                            {componentProperties.elements}
                        </div>
                    </Draggable>
                    {scroll}
                </div>
            );
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/ScrollableComponent.js
 **/